<template>
  <div class="w-100">
    <template v-if="this.$isNotEmptyV2(products)">
      <ProductCartPrimaryStyle
        ref="productCart"
        v-if="page === 'CART'"
        :products="products"
        @removeProduct="removeProduct"
       />
       <ProductCartLightStyle
        v-if="page === 'SEARCH'"
        :products="products"
        :bg-color="bgColor"
        @removeProduct="removeProduct"
       />
       <ProductCartWhiteStyle
        v-if="page === 'CART-ADDITIONAL'"
        ref="productCart"
        :products="products"
        :hide-remove="hideRemove"
        @removeProduct="removeProduct"
       />
    </template>
  </div>
</template>

<script>
  import moment from 'moment';
  import { mapGetters,mapMutations } from 'vuex';
  import { normalizeGuestList } from '@/utils/activityCart.js';
  import ProductCartPrimaryStyle from './ProductCartPrimaryStyle.vue';
  import ProductCartLightStyle from './ProductCartLightStyle.vue';
  import ProductCartWhiteStyle from './ProductCartWhiteStyle.vue';

  export default {
    components:{
      ProductCartPrimaryStyle,
      ProductCartLightStyle,
      ProductCartWhiteStyle
    },
    props: {
      page: {
        type: String,
        default: "CART"
      },
      bgColor: {
        type: String,
        default: "bg-light"
      },
      hideRemove: {
        type: Boolean,
        default: true
      }
    },
    computed:{
      ...mapGetters([
        'getMerchant',
        'getBeCartAddtService',
        'getActivityTrxProducts',
        'getOutletTrxProducts',
        'getVoucherOrder',
        'getOutletTrxPageModule',
        'getActivityTrxPageModule',
        'getVoucherPageModule'
      ]),
      products(){
        let all_product = []

        // hide_product_image lives on the POS general config, cached when the module was browsed
        const isImageHidden = (productMerchantPos) => {
          if(this.$isEmpty(productMerchantPos)) return false
          return this.$isProductImageHidden(this.$getModuleConfig(productMerchantPos[0].id))
        }
        
        const getPricing = (pricing, qty = null) => {
          const { 
            tax_service_calculation_type, 
            price_sell_final,
            price_sell_final_with_tax_service,
            price_sell_base,
            service_amount,
            tax_amount
          } = pricing;

          const isTaxIncludeOrEmpty = this.$isEmpty(tax_service_calculation_type) || tax_service_calculation_type === 'INCLUDE';
          
          const baseWithTax = price_sell_base + service_amount + tax_amount
          const basedOnTaxType = isTaxIncludeOrEmpty ? price_sell_base : baseWithTax

          let price = {
            base: price_sell_base,
            baseWithTax: basedOnTaxType,
            final: price_sell_final,
            finalWithTax: price_sell_final_with_tax_service,
            discount: basedOnTaxType - price_sell_final_with_tax_service
          }

          if(this.$isNotEmptyV2(qty)) price = Object.fromEntries(Object.entries(price).map(([key, value]) => [key, value * qty]));
          
          return price
        }

        const getPromotion = (promotionFromApi, discountAmount) => {
          if(this.$isEmpty(promotionFromApi)) return { promotionName: "", discountText: "" }
          
          return {
            promotionName: promotionFromApi.name,
            discountText: `You get a discount of ${this.$formatCurrency(discountAmount)} from this promo`
          }
        }

        const assignProduct = ({type, parentData, assignedData, qty, isVariant, moduleData="", ref, refVariant = {}}) => {
          const { name: parentName,image_url, product_merchant_pos, product_pos, unit } = parentData
          const { id, name, price: priceData, promotion_affected } = assignedData

          const productName = isVariant ? `${name} - ${parentName}` : name
          
          let moduleName = moduleData
          if(this.$isEmpty(moduleData)){
            if(isVariant){
              moduleName = this.$isNotEmpty(product_pos) ? product_pos[0].name : ""
            }else{
              moduleName = this.$isNotEmpty(product_merchant_pos) ? product_merchant_pos[0].name : ""
            }
          }

          const price = getPricing(priceData, qty);
          const promotion = getPromotion(promotion_affected.best, price.discount);   
          
          all_product.push({
            type, 
            ref_data: ref,
            ref_data_variant: refVariant,
            module: moduleName,
            name: productName,
            other: "",
            unit: this.$isNotEmpty(unit) ? unit.unit : "",
            hideImage: isImageHidden(product_merchant_pos),
            id, price, image_url, qty, price, promotion, form_flight_number: "HIDE", flight_number: ""
          })
        }
        
        // ORIGINAL
        this.getBeCartAddtService.forEach(original => {

          let {image_url,name,price,unit,category,id, form_flight_number } = original.data

          const flight_number = this.$isNotEmptyV2(original.flight_number) ? original.flight_number : "";
          
          let new_data = {
            type: 'ORIGINAL', id,
            hideImage: false,
            module: category.name,
            ref_data: original,
            image_url: image_url,
            name: name,
            price:{
              base: price,
              baseWithTax: price,
              final: price,
              finalWithTax: price,
            },
            qty: original.qty,
            unit: this.$isNotEmpty(unit) ? unit.unit : "",
            other: '',
            promotion: "",
            form_flight_number,
            flight_number
          }

          all_product.push(new_data)
        });

        // SPA/ACTIVITY
        this.getActivityTrxProducts.forEach(activity=>{
          const {
            original_data : { id, image_url: singleImage, image_list, name, guest_include, product_merchant_pos, promotion_affected },
            base_price: { source },
            guest_list,
            qty,
            service_date,
            service_time
          } = activity

          const price = getPricing(source);
          const module = this.$isNotEmpty(product_merchant_pos) ? product_merchant_pos[0].name : "";
          const image_url = image_list.length == 0 ? singleImage : image_list[0].image_url;
          const promotion = getPromotion(promotion_affected.best, price.discount);          

          const isGuestIncludedExist = this.$isNotEmpty(guest_include);
          let unit = "";
          if(isGuestIncludedExist) unit = guest_include == 1 ? 'Person' : 'Package'

          const guestText = guest_include > 0
            ? normalizeGuestList(guest_list, qty, guest_include).join(', ')
            : ""

          const serviceDateRaw = moment(service_date).format("YYYY-MM-DD")
          const serviceDateTime = moment(`${serviceDateRaw} ${service_time.schedule_start}`, 'YYYY-MM-DD HH:mm:ss')
          const other = this.$formatDateTime(serviceDateTime);
          
          all_product.push({
            type: 'ACTIVITY',
            ref_data: activity,
            hideImage: isImageHidden(product_merchant_pos),
            guestText,
            id, name, price, module, image_url, unit, qty, price, promotion, other, form_flight_number: "HIDE", flight_number: ""
          })
        })
        
        // OUTLET
        this.getOutletTrxProducts.forEach(outlet=>{
          const { product_data: parentData, variants, qty } = outlet
          
          const isProductVariant = variants.length > 0

          const fixParams = { type: "OUTLET", parentData, isVariant: isProductVariant, ref: outlet }
          
          if(isProductVariant) {
            variants.forEach(variant => {
              assignProduct({
                ...fixParams,
                assignedData: variant.variant_data, 
                qty: variant.qty,
                refVariant: variant
              })
            })
          } else {
            assignProduct({
              ...fixParams,
              qty,
              assignedData: parentData, 
              isVariant: isProductVariant
            })
          }

        })

        // VOUCHER
        this.getVoucherOrder.cart.forEach(voucher_parent=>{
          voucher_parent.product.forEach(voucher=>{
            const { data: parentData, qty, is_variant: isVariant, variant_list } = voucher

            const fixParams = { type: "VOUCHER", parentData, isVariant, ref: voucher, moduleData: "Voucher" }
            
            if(isVariant){
              variant_list.forEach(variant=>{
                assignProduct({
                  ...fixParams,
                  qty: variant.qty,
                  assignedData: variant.data,
                  refVariant: variant
                })
              })
            }else{
              assignProduct({ 
                ...fixParams,
                qty,
                assignedData: parentData, 
              })
            }
          })
          
        })
        
        return all_product
      }
    },
    mounted(){
      this.$emit('register-ref', this.$refs.productCart)
      this.validatePageModule()
    },
    methods:{
      ...mapMutations([
        'BeRemoveAddtService',
        'removeTrxActivityProduct',
        'removeTrxOutletProduct',
        'removeVoucherOrder',
        'clearTrxOutletProduct',
        'clearTrxActivityProduct',
        'resetAllDataMarketing'
      ]),
      validatePageModule(){
        if(!(this.getOutletTrxPageModule == '' || this.getOutletTrxPageModule == 'additional_service')){
          this.clearTrxOutletProduct()
        }
        if(!(this.getActivityTrxPageModule == '' || this.getActivityTrxPageModule == 'additional_service')){
          this.clearTrxActivityProduct()
        }
        if(!(this.getVoucherPageModule == '' || this.getVoucherPageModule == 'Cart')){
          this.resetAllDataMarketing()
        }
      },
      removeProduct(product){
        let {type,ref_data,ref_data_variant} = product
        if(type == 'ORIGINAL'){
          this.BeRemoveAddtService(ref_data.data)
        }else if(type == 'ACTIVITY'){
          this.removeTrxActivityProduct({
            product: ref_data.original_data
          })
        }else if(type == 'OUTLET'){
          let is_variant = ref_data.variants.length > 0
          let params = {
            product: ref_data.product_data,
            variant: is_variant ? ref_data_variant.variant_data : {},
            ref:  is_variant ? 'variant' : 'product',
            qty: product.qty,
            notes: product.notes
          }
          this.removeTrxOutletProduct(params)
        }else if(type == 'VOUCHER'){
          let params = {
            product: ref_data.data,
            variant: ref_data_variant
          }
          this.removeVoucherOrder(params)
        }
      }
    }
  }
</script>
<style>
  .addt_srv_cart .image{
    width: 75px;
    height: auto;
    border-radius: 6px;
    overflow: hidden;
    flex-shrink: 0;
  }
  .addt_srv_cart .remove-btn{
    cursor: pointer;
    flex-shrink: 0;
    border-radius: 6px;
    background-color: #FFF;
    height: 34px; 
    width: 34px; 
    display: grid;
    place-items: center;
  }
</style>


// WEBPACK FOOTER //
// src/components/hotel/be/additionalService/ProductCart.vue